import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import HomeHeader from "./header/HomeHeader";

const HomeLayout = () => {
  return (
    <>
      <HomeHeader />
      <Box component="main" sx={{ p: 3 }}>
        <Outlet />
      </Box>
    </>
  );
};

export default HomeLayout;
